import { useEffect, useState } from 'react';

import { useProductsByCategoryLang } from './useProductsByCategoryLang';

import type { MouseEvent } from 'react';
import type { FullMenuCatalog, IMenuProduct } from 'features/menu-page/domain';

const INIT_SELECTED: IMenuProduct = {
  id: NaN,
  storeId: NaN,
  categoryId: NaN,
  index: 0,
  name: '',
  description: '',
  image: '',
  isOn: false,
  hasCustomizations: false,
  suspensionInfo: {
    reason: null,
    shutdownDate: null,
    activationDate: null,
  },
} as const;

export function useProductsByCategory(props: Props) {
  const { catalog } = props;

  const [collapse, setCollapse] = useState(NaN);
  const [selectedProduct, setSelectedProduct] = useState(INIT_SELECTED);

  const lang = useProductsByCategoryLang();

  const showInternalCustoms =
    !isNaN(selectedProduct.id) && selectedProduct.hasCustomizations;

  const handleClickCollapse = (e: MouseEvent<HTMLButtonElement>) => {
    const categoryId = Number(e.currentTarget.dataset.categoryId);
    setCollapse(categoryId === collapse ? NaN : categoryId);
    setSelectedProduct(INIT_SELECTED);
  };

  const handleClickProduct = (p: IMenuProduct) => setSelectedProduct(p);

  useEffect(() => {
    if (catalog.categories.length === 1) setCollapse(catalog.categories[0].id);
  }, [catalog]);

  return {
    lang,
    collapse,
    showInternalCustoms,
    selectedProduct,
    productsWithoutCategory: catalog.products.filter(p => isNaN(p.categoryId)),
    handleClickCollapse,
    handleClickProduct,
  };
}

interface Props {
  catalog: FullMenuCatalog;
}
